<template>
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.0675 0.777344H0V4.06584H10.0675V0.777344Z" fill="#FE6100" />
    <path d="M10.0675 5.79102H0V9.07952H10.0675V5.79102Z" fill="#FE6100" />
  </svg>
</template>
